// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
window.jQuery = $;
window.$ = $;
import Rails from '@rails/ujs';
import Turbolinks from 'turbolinks';
import * as ActiveStorage from '@rails/activestorage';
import 'channels';
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
import '../theme/scripts.bundle.js';
import 'jquery-validation';
require('packs/modals');
require('packs/school_class_form');
require('packs/school_classes_index');
require('packs/timer');
require('packs/strand_reporting');
require('packs/assessments_import_audio_modal');
require('packs/setup_wizard');
require('views/pcc_assessment_settings');
require('views/pcc_assessments');
require('packs/popovers');
require('packs/charts');
require('select2/dist/js/select2.js');
require('flatpickr/dist/flatpickr');
require('@nathanvda/cocoon');
import LocalTime from 'local-time';
LocalTime.start();
Rails.start();
Turbolinks.start();
ActiveStorage.start();

$(document).on('turbolinks:load', function () {
  if (document.body && document.body.dataset.showTermsModal === 'true') {
    $('#terms-modal').modal('show');
  }
  // Initialize Bootstrap tooltips/popovers/dropdowns
  $('[data-bs-toggle="tooltip"]').tooltip();
  $('[data-bs-toggle="popover"]').popover();
  document.querySelectorAll('[data-bs-toggle="dropdown"]').forEach(function (dropdown) {
    new bootstrap.Dropdown(dropdown);
  });

  // Initialize KT menu if present
  var menuElement = document.querySelector('[data-kt-menu="true"]');
  if (menuElement && typeof KTMenu !== 'undefined') {
    new KTMenu(menuElement, {
      accordion: {
        slideSpeed: 250,
        expand: false,
      },
      submenu: {
        desktop: 'accordion',
        tablet: 'accordion',
        mobile: 'accordion',
      },
    });
  }

  // select.select2, not .select2 — don't match select2's own rendered wrapper span
  $('select.select2').select2({
    theme: 'bootstrap-5',
  });

  $('.grade-select').on('change', function () {
    var isTeacher = $('.is-teacher');

    if (this.value === 'teacher') {
      isTeacher[0].checked = true;
      isTeacher[1].checked = false;
    } else {
      isTeacher[0].checked = false;
      isTeacher[1].checked = true;
    }
  });
  $(".validate").validate();
  $('.validate_test').validate({
    invalidHandler: function (form, validator) {
      var errors = validator.numberOfInvalids();

      if (errors) {
        $('#error-message').show().text('Please select at least one option');
      } else {
        $('#error-message').hide();
      }
    },
    messages: {
      answer: {
        required: '',
      },
    },
  });
  // datepicker
  flatpickr('.datepicker', {
    altInput: true,
    dateFormat: 'm/d/Y',
  });
  flatpickr('.datetime_picker', {
    altInput: true,
    enableTime: true,
    allowInput: false,
    dateFormat: 'm/d/Y H:i',
  });

  flatpickr('.time_picker', {
    enableTime: true,
    noCalendar: true,
    altInput: true,
    dateFormat: 'm/d/Y H:i',
  });

  // locale
  window.I18n = {
    translations: {},
    t: function(key) {
      return this.translations[key] || key;
    }
  };

  function loadTranslations() {
    $.ajax({
      url: '/translations',
      method: 'GET',
      success: function(data) {
        window.I18n.translations = data;
      }
    });
  }
  
  $(document).ready(function() {
    loadTranslations();
  });
  

  // Data Tables
  var dataTables = $('.data-table');

  var customDataTable = function customDataTable(elem) {
    elem.find('.pagination').addClass('pagination-sm');
  };

  dataTables.length &&
    dataTables.each(function (index, value) {
      var $this = $(value);
      var options = $.extend(
        {
          responsive: true,
          paging: false,
          searching: false,
          dom:
            "<'row mx-1'<'col-sm-12 col-md-6 px-3'l><'col-sm-12 col-md-6 px-3'f>>" +
            "<'table-responsive'tr>" +
            "<'row mx-1 align-items-center justify-content-center justify-content-md-between'<'col-auto mb-2 mb-sm-0'i><'col-auto'p>>",
        },
        $this.data('options')
      );
      $this.DataTable(options);
      var $wrpper = $this.closest('.dataTables_wrapper');
      customDataTable($wrpper);
      $this.on('draw.dt', function () {
        return customDataTable($wrpper);
      });
    });
  function searchUers(value) {
    var htmlList = '';
    var searchUrl = '/admin/full_search?q=' + encodeURIComponent(value);
    
    // getting json data from file for search results
    $.get(searchUrl)
      .done(function (data) {
        
        // Clear previous results
        $('ul.header-search-list').empty();
        
        // Check if we have actual results (not just "No results found" message)
        var hasResults = false;
        for (var i = 0; i < data.length; i++) {
          // Check if this item is not the "No results found" message
          if (data[i].list_html && !data[i].list_html.includes('No results found') && !data[i].list_html.includes('No result found')) {
            hasResults = true;
          }
          // Ensure we're using the HTML string, not escaping it
          var htmlString = data[i].list_html;
          if (typeof htmlString === 'string') {
            htmlList += htmlString;
          } else {
            htmlList += String(htmlString);
          }
        }
        
        
        // Update the DOM - append each item to ensure proper parsing
        var $list = $('ul.header-search-list');
        $list.empty();
        
        // Append each HTML string as a properly parsed DOM element
      for (var i = 0; i < data.length; i++) {
          if (data[i].list_html) {
            // Trim whitespace and remove any problematic characters
            var htmlString = data[i].list_html.trim();
            // Try to parse as jQuery object
            try {
              var $item = $(htmlString);
              if ($item.length > 0) {
                $list.append($item);
              } else {
                // Fallback: try appending as raw HTML
                $list.append(htmlString);
              }
            } catch (e) {
              // Fallback: try appending as raw HTML
              $list.append(htmlString);
            }
          }
        }
        
        if ($list.children().length > 0) {
          var $first = $list.children().first();
        }
        
        // Show/hide appropriate containers
        var $resultsDiv = $('[data-kt-search-element="results"]');
        var $mainDiv = $('[data-kt-search-element="main"]');
        var $emptyDiv = $('[data-kt-search-element="empty"]');
        var $menuContent = $('[data-kt-search-element="content"]');
        var $listItems = $('ul.header-search-list li');
        
        
        if (hasResults) {
          // Show results, hide main and empty
          $resultsDiv.removeClass('d-none').css({
            'display': 'block',
            'visibility': 'visible',
            'opacity': '1',
            'z-index': '9999',
            'position': 'relative'
          });
          $mainDiv.addClass('d-none');
          if ($mainDiv[0]) {
            $mainDiv[0].style.setProperty('display', 'none', 'important');
          }
          
          // Force hide empty div with inline styles
          $emptyDiv.addClass('d-none');
          if ($emptyDiv[0]) {
            $emptyDiv[0].style.setProperty('display', 'none', 'important');
            $emptyDiv[0].style.setProperty('visibility', 'hidden', 'important');
            $emptyDiv[0].style.setProperty('opacity', '0', 'important');
          }
          
          
          // Ensure the menu dropdown container is visible and on top with proper positioning
          // Calculate position using viewport coordinates to ensure menu is always visible
          var $searchContainer = $('#kt_header_search');
          var $formElement = $searchContainer.find('form[data-kt-search-element="form"]');
          var $inputElement = $('.header-search-input');
          
          // Try to get position from form element first, then input, then container
          var targetRect = null;
          if ($formElement.length && $formElement[0]) {
            targetRect = $formElement[0].getBoundingClientRect();
          } else if ($inputElement.length && $inputElement[0]) {
            targetRect = $inputElement[0].getBoundingClientRect();
          } else if ($searchContainer[0]) {
            targetRect = $searchContainer[0].getBoundingClientRect();
          }
          
          // Use fixed positioning based on viewport coordinates
          // Apply positioning as inline styles with !important to override Keen Theme
          var menuElInitial = $menuContent[0];
          if (menuElInitial && targetRect) {
            menuElInitial.style.setProperty('position', 'fixed', 'important');
            menuElInitial.style.setProperty('top', targetRect.bottom + 'px', 'important');
            menuElInitial.style.setProperty('left', targetRect.left + 'px', 'important');
            menuElInitial.style.setProperty('transform', 'none', 'important'); // Remove any transforms
            menuElInitial.style.setProperty('margin', '0', 'important');
            menuElInitial.style.setProperty('margin-left', '0', 'important');
            menuElInitial.style.setProperty('margin-top', '0', 'important');
            // Use search container width or minimum 350px
            var menuWidth = Math.max(targetRect.width || 350, 350);
            menuElInitial.style.setProperty('width', menuWidth + 'px', 'important');
            menuElInitial.style.setProperty('min-width', menuWidth + 'px', 'important');
            menuElInitial.style.setProperty('max-width', menuWidth + 'px', 'important');
          }
          
          $menuContent.show().css({
            'display': 'block',
            'visibility': 'visible',
            'z-index': '99999'
          });
          
          // Also ensure parent is positioned for fallback
          if ($searchContainer.length) {
            var searchContainerPosition = $searchContainer.css('position');
            if (searchContainerPosition === 'static' || !searchContainerPosition) {
              $searchContainer.css('position', 'relative');
            }
          }
          
          
          // Ensure the parent wrapper is visible and has full width
          var $wrapper = $resultsDiv.closest('[data-kt-search-element="wrapper"]');
          $wrapper.show().css({
            'display': 'block',
            'visibility': 'visible',
            'z-index': '9999',
            'overflow': 'visible',
            'height': 'auto',
            'min-height': 'auto',
            'width': '100%',
            'max-width': '100%'
          });
          if ($wrapper[0]) {
            $wrapper[0].style.setProperty('width', '100%', 'important');
            $wrapper[0].style.setProperty('max-width', '100%', 'important');
          }
          
          // Ensure the scroll container is visible and has proper height and full width
          var $scrollContainer = $resultsDiv.find('.scroll-y');
          if ($scrollContainer.length) {
            $scrollContainer.css({
              'display': 'block',
              'visibility': 'visible',
              'overflow-y': 'auto',
              'overflow-x': 'hidden',
              'max-height': '350px',
              'min-height': '100px',
              'width': '100%',
              'max-width': '100%'
            });
            $scrollContainer[0].style.setProperty('width', '100%', 'important');
            $scrollContainer[0].style.setProperty('max-width', '100%', 'important');
          }
          
          // Ensure results div has proper height, overflow, and full width
          $resultsDiv.css({
            'overflow': 'visible',
            'max-height': 'none',
            'min-height': 'auto',
            'width': '100%',
            'max-width': '100%'
          });
          if ($resultsDiv[0]) {
            $resultsDiv[0].style.setProperty('width', '100%', 'important');
            $resultsDiv[0].style.setProperty('max-width', '100%', 'important');
          }
          
          // Ensure the ul is visible and has proper styling with full width
          $list.css({
            'display': 'block',
            'visibility': 'visible',
            'color': '#181C32', // Dark text color
            'z-index': '9999',
            'width': '100%',
            'max-width': '100%'
          });
          if ($list[0]) {
            $list[0].style.setProperty('width', '100%', 'important');
            $list[0].style.setProperty('max-width', '100%', 'important');
            $list[0].style.setProperty('padding-left', '0', 'important');
            $list[0].style.setProperty('margin', '0', 'important');
          }
          
          // Ensure all list items are visible and have full width
          $list.find('li').css({
            'display': 'block',
            'visibility': 'visible',
            'color': '#181C32', // Dark text color
            'opacity': '1',
            'width': '100%',
            'max-width': '100%'
          });
          $list.find('li').each(function() {
            this.style.setProperty('width', '100%', 'important');
            this.style.setProperty('max-width', '100%', 'important');
          });
          
          // Ensure links are visible and have full width
          $list.find('a').css({
            'color': '#181C32',
            'text-decoration': 'none',
            'width': '100%',
            'max-width': '100%'
          });
          $list.find('a').each(function() {
            this.style.setProperty('width', '100%', 'important');
            this.style.setProperty('max-width', '100%', 'important');
          });
          
          // Ensure spans have visible text
          $list.find('span').css({
            'color': '#181C32'
          });
          
          // Make sure the parent search container has proper z-index
          $('#kt_header_search').css({ 'z-index': '9999', 'position': 'relative' });
          
          
          // Force focus on input to trigger menu opening
          var $input = $('.header-search-input');
          if ($input.length) {
            setTimeout(function() {
              $input.focus();
            }, 50);
          }
          
          // Trigger Keen Theme search complete to show the menu
          setTimeout(function() {
            var searchElement = document.getElementById('kt_header_search');
            var $searchContainerTimeout = $('#kt_header_search');
            
            // Try multiple ways to access KTSearch
            var KTSearchClass = typeof KTSearch !== 'undefined' ? KTSearch : 
                                (typeof window !== 'undefined' && window.KTSearch ? window.KTSearch : null);
            
            if (searchElement && KTSearchClass) {
              var searchInstance = KTSearchClass.getInstance(searchElement);
              if (searchInstance) {
                searchInstance.complete();
                
                // Also try to get the menu and show it directly
                var menuInstance = searchInstance.getMenu();
                if (menuInstance && typeof menuInstance.show === 'function') {
                  menuInstance.show(searchElement);
                }
                
                // Also call show on search instance
                if (typeof searchInstance.show === 'function') {
                  searchInstance.show();
                }
              }
            }
            
            // Force the menu to be visible - remove any hidden classes and set inline styles
            if ($menuContent.length) {
              var menuEl = $menuContent[0];
              $menuContent.removeClass('d-none').addClass('show');
              menuEl.style.setProperty('display', 'block', 'important');
              menuEl.style.setProperty('visibility', 'visible', 'important');
              menuEl.style.setProperty('opacity', '1', 'important');
              menuEl.style.setProperty('z-index', '99999', 'important');
              menuEl.style.setProperty('position', 'fixed', 'important');
              
              // Calculate position using viewport coordinates - use form or input element
              var $formElementTimeout = $searchContainerTimeout.find('form[data-kt-search-element="form"]');
              var $inputElementTimeout = $('.header-search-input');
              
              var targetRectTimeout = null;
              if ($formElementTimeout.length && $formElementTimeout[0]) {
                targetRectTimeout = $formElementTimeout[0].getBoundingClientRect();
              } else if ($inputElementTimeout.length && $inputElementTimeout[0]) {
                targetRectTimeout = $inputElementTimeout[0].getBoundingClientRect();
              } else if ($searchContainerTimeout.length && $searchContainerTimeout[0]) {
                targetRectTimeout = $searchContainerTimeout[0].getBoundingClientRect();
              }
              
              if (targetRectTimeout) {
                menuEl.style.setProperty('top', targetRectTimeout.bottom + 'px', 'important');
                menuEl.style.setProperty('left', targetRectTimeout.left + 'px', 'important');
                menuEl.style.setProperty('transform', 'none', 'important'); // Remove any transforms
                menuEl.style.setProperty('margin', '0', 'important');
                menuEl.style.setProperty('margin-left', '0', 'important');
                menuEl.style.setProperty('margin-top', '0', 'important');
                // Set width to match search container width
                var menuWidthTimeout = Math.max(targetRectTimeout.width || 350, 350);
                menuEl.style.setProperty('width', menuWidthTimeout + 'px', 'important');
                menuEl.style.setProperty('min-width', menuWidthTimeout + 'px', 'important');
                menuEl.style.setProperty('max-width', menuWidthTimeout + 'px', 'important');
              } else {
                menuEl.style.setProperty('top', '100%', 'important');
                menuEl.style.setProperty('left', '0', 'important');
              }
              
              menuEl.style.setProperty('height', 'auto', 'important');
              menuEl.style.setProperty('min-height', 'auto', 'important');
              menuEl.style.setProperty('max-height', 'none', 'important');
              menuEl.style.setProperty('overflow', 'visible', 'important');
              
              // Also ensure wrapper and scroll container are visible with proper sizing and full width
              var $wrapper = $menuContent.find('[data-kt-search-element="wrapper"]');
              if ($wrapper.length) {
                $wrapper[0].style.setProperty('display', 'block', 'important');
                $wrapper[0].style.setProperty('overflow', 'visible', 'important');
                $wrapper[0].style.setProperty('height', 'auto', 'important');
                $wrapper[0].style.setProperty('width', '100%', 'important');
                $wrapper[0].style.setProperty('max-width', '100%', 'important');
              }
              
              var $scrollY = $menuContent.find('.scroll-y');
              if ($scrollY.length) {
                $scrollY[0].style.setProperty('display', 'block', 'important');
                $scrollY[0].style.setProperty('max-height', '350px', 'important');
                $scrollY[0].style.setProperty('overflow-y', 'auto', 'important');
                $scrollY[0].style.setProperty('overflow-x', 'hidden', 'important');
                $scrollY[0].style.setProperty('width', '100%', 'important');
                $scrollY[0].style.setProperty('max-width', '100%', 'important');
              }
              
              // Ensure results div doesn't constrain height and has full width
              var $resultsDivInner = $menuContent.find('[data-kt-search-element="results"]');
              if ($resultsDivInner.length) {
                $resultsDivInner[0].style.setProperty('overflow', 'visible', 'important');
                $resultsDivInner[0].style.setProperty('max-height', 'none', 'important');
                $resultsDivInner[0].style.setProperty('display', 'block', 'important');
                $resultsDivInner[0].style.setProperty('width', '100%', 'important');
                $resultsDivInner[0].style.setProperty('max-width', '100%', 'important');
              }
              
              // Ensure ul and li elements have full width
              var $listTimeout = $menuContent.find('ul.header-search-list');
              if ($listTimeout.length && $listTimeout[0]) {
                $listTimeout[0].style.setProperty('width', '100%', 'important');
                $listTimeout[0].style.setProperty('max-width', '100%', 'important');
                $listTimeout[0].style.setProperty('padding-left', '0', 'important');
                $listTimeout[0].style.setProperty('margin', '0', 'important');
              }
              
              $listTimeout.find('li').each(function() {
                this.style.setProperty('width', '100%', 'important');
                this.style.setProperty('max-width', '100%', 'important');
              });
              
              $listTimeout.find('a').each(function() {
                this.style.setProperty('width', '100%', 'important');
                this.style.setProperty('max-width', '100%', 'important');
              });
              
              // Force hide empty div again (in case Keen Theme API showed it)
              var $emptyDivInner = $menuContent.find('[data-kt-search-element="empty"]');
              if ($emptyDivInner.length) {
                $emptyDivInner[0].style.setProperty('display', 'none', 'important');
                $emptyDivInner[0].style.setProperty('visibility', 'hidden', 'important');
                $emptyDivInner[0].style.setProperty('opacity', '0', 'important');
              }
              
              // Force hide main div
              var $mainDivInner = $menuContent.find('[data-kt-search-element="main"]');
              if ($mainDivInner.length) {
                $mainDivInner[0].style.setProperty('display', 'none', 'important');
              }
              
            }
            
          }, 150);
        } else {
          // Show empty message, hide results and main
          $resultsDiv.addClass('d-none');
          $mainDiv.addClass('d-none');
          $emptyDiv.removeClass('d-none');
          $menuContent.show().css('display', 'block');
        }
      })
      .fail(function (jqXHR, textStatus, errorThrown) {
        // Show empty message on error
        $('[data-kt-search-element="results"]').addClass('d-none');
        $('[data-kt-search-element="main"]').addClass('d-none');
        $('[data-kt-search-element="empty"]').removeClass('d-none');
    });
  }
  var timer = null;
  // top search area start
  $('.header-search-input').on('keyup', function (e) {
    if (e.keyCode !== 38 && e.keyCode !== 40 && e.keyCode !== 13) {
      if (e.keyCode == 27) {
        $('.search-input').removeClass('d-block');
        $('.app-content').removeClass('show-overlay');
      }
      var value = $(this).val().toLowerCase();
      var liList = $('ul.header-search-list li'); // get all the list items of the search
      liList.remove();
      if (value != '') {
        $('.header-search-list').addClass('d-block');
        $('.app-content').addClass('show-overlay');
        clearTimeout(timer);
        timer = setTimeout(function() { searchUers(value); }, 1000);
      } else {
        // If filter box is empty
        if ($('.header-search-list').hasClass('d-block')) {
          $('.header-search-list').removeClass('d-block');
        }
        $('.app-content').removeClass('show-overlay');
      }
    }
    $('input[type=search]').on('search', function () {
      $('.header-search-list').removeClass('d-block');
      $('.app-content').removeClass('show-overlay');
    });
  });
  // top search area end
  // open search card and close it
  $('.open-search').on('click', function () {
    $('.search-card').toggleClass('d-none');
    return false;
  });
  $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
    // save the latest tab; use cookies if you like 'em better:
    localStorage.setItem('lastTab', $(this).attr('href'));
  });

  // go to the latest tab, if it exists — unless the URL explicitly requests a
  // subject area (e.g. ?sa_id=2 from the diocese School List), which takes
  // precedence over the remembered tab (the server already activates it).
  var hasSaParam = new URLSearchParams(window.location.search).has('sa_id');
  var lastTab = localStorage.getItem('lastTab');
  if (lastTab && !hasSaParam) {
    $('[href="' + lastTab + '"]').tab('show');
  }

  // dynamic dropdowns
  var $diocese = $('.diocese-select').select2({ theme: 'bootstrap-5' });
  var $testing_center = $('.testing-center-select').select2({
    theme: 'bootstrap-5',
  });

  $diocese.on('select2:select', function (e) {
    $.ajax({
      method: 'GET',
      data: { diocese: $(this).val() },
      url: '/admin/centers_list',
    }).done(function (resp) {
      $('.testing-center-select').empty().trigger('change');
      // create the option and append to Select2
      $.each(resp, function (i, value) {
        var option = new Option(value.text, value.id, true, true);
        $testing_center.append(option);
      });
      $('.testing-center-select').trigger('change');
      $('.testing-center-select').val(null).trigger('change');
    });
  });

  $('.testing-center-select').on('change', function () {
    $.ajax({
      method: 'GET',
      data: { testing_center: $(this).val(), current_year: $(this).data("year") },
      url: '/admin/testing_center_assessment',
    }).done(function (resp) {
      $('.testing-center-assessment').empty().trigger('change');
      // create the option and append to Select2
      $.each(resp, function (i, value) {
        var option = new Option(value.text, value.id, true, true);
        $('.testing-center-assessment').append(option);
      });
      $('.testing-center-assessment').trigger('change');
      $('.testing-center-assessment').val(null).trigger('change');
    });
  });
  $(document).on('select2:open', () => {
    document.querySelector('.select2-search__field').focus();
  });
});


function handleNavbarVerticalCollapsed() {
  var Selector = {
    HTML: 'html',
    NAVBAR_VERTICAL_TOGGLE: '.navbar-vertical-toggle',
    NAVBAR_VERTOCAL_COLLAPSE: '.navbar-vertical .navbar-collapse',
    ECHART_RESPONSIVE: '[data-echart-responsive]',
  };
  var Events = {
    CLICK: 'click',
    MOUSE_OVER: 'mouseover',
    MOUSE_LEAVE: 'mouseleave',
    NAVBAR_VERTICAL_TOGGLE: 'navbar.vertical.toggle',
  };
  var ClassNames = {
    NAVBAR_VERTICAL_COLLAPSED: 'navbar-vertical-collapsed',
    NAVBAR_VERTICAL_COLLAPSED_HOVER: 'navbar-vertical-collapsed-hover',
  };
  var navbarVerticalToggle = document.querySelector(
    Selector.NAVBAR_VERTICAL_TOGGLE
  );
  var html = document.querySelector(Selector.HTML);
  var navbarVerticalCollapse = document.querySelector(
    Selector.NAVBAR_VERTICAL_COLLAPSE
  );

  if (navbarVerticalToggle) {
    navbarVerticalToggle.addEventListener(Events.CLICK, function (e) {
      html.classList.toggle(ClassNames.NAVBAR_VERTICAL_COLLAPSED); // Set collapse state on localStorage

      var isNavbarVerticalCollapsed = utils.getItemFromStore(
        'isNavbarVerticalCollapsed'
      );
      utils.setItemToStore(
        'isNavbarVerticalCollapsed',
        !isNavbarVerticalCollapsed
      );
      var event = new CustomEvent(Events.NAVBAR_VERTICAL_TOGGLE);
      e.currentTarget.dispatchEvent(event);
    });
  }

  if (navbarVerticalCollapse) {
    navbarVerticalCollapse.addEventListener(Events.MOUSE_OVER, function () {
      if (utils.hasClass(html, ClassNames.NAVBAR_VERTICAL_COLLAPSED)) {
        html.classList.add(ClassNames.NAVBAR_VERTICAL_COLLAPSED_HOVER);
      }
    });
    navbarVerticalCollapse.addEventListener(Events.MOUSE_LEAVE, function () {
      if (utils.hasClass(html, ClassNames.NAVBAR_VERTICAL_COLLAPSED_HOVER)) {
        html.classList.remove(ClassNames.NAVBAR_VERTICAL_COLLAPSED_HOVER);
      }
    });
  }
}
